import axios from "@/axios"; 
const API_URL = process.env.VUE_APP_API_BASE_URL;
export function useRefreshOltApi() {
  async function refreshOlt(ecom_portid, olt_id) {
    try {
      const response = await axios.get(API_URL + `/snmp-query/?value=${ecom_portid}&oltid=${olt_id}`);
      return response.data;
    } catch (error) {
      console.error("Error refreshing data:", error);
      throw error;
    }
  }
  
  return {
    refreshOlt
  };
}